import { createStyles } from '@mantine/core'

export default createStyles((theme) => {
  return {
    root: {
      gap: 12,
      padding: 8,
      alignItems: 'center',
      borderRadius: 16,
      backgroundColor: '#fff',
      boxShadow: `0px 0px 1px 0px #0000000A,0px 0px 2px 0px #0000000F,0px 4px 8px 0px #0000000A`,
      [theme.fn.largerThan('sm')]: {
        flexDirection: 'column',
        textAlign: 'center',
        gap: 8,
        padding: 16,
        minHeight: 180,
      },
    },
  }
})
